import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const BuildingsTown = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="m14 3 5.133 4.447c.232.201.367.502.367.82V21M18 3l3.6 2.859c.252.2.4.514.4.847V21m-12-3.177v2.648M3 9.84v10.1c0 .586.448 1.06 1 1.06h12c.552 0 1-.474 1-1.059V9.84c0-.31-.128-.603-.35-.804l-6-5.445a.96.96 0 0 0-1.3 0l-6 5.445c-.222.201-.35.495-.35.804Zm8 2.69c0 .584-.448 1.058-1 1.058s-1-.474-1-1.059c0-.584.448-1.058 1-1.058s1 .474 1 1.058Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(BuildingsTown) as SvgIcon;
export { ForwardRef as ReactComponent };
